const mixins = {
    methods: {
        /**
         *
         * @param {string} componentName // The name of modal to call
         * @param {object} props // All data that you need to transmitted to modal
         * @param {*} emitter // If you need to define emitter in specific context
         * @param {string} layout // If you need to encompass your modal in layout (in /components/Modal/layouts)
         */
        openModal(
            componentName,
            props = null,
            emitter = null,
            layout = "center"
        ) {
            if (emitter) {
                this.emitter = emitter
            }
            let modalTitle = ""
            let modalClass = ""
            // Existing class : small, medium, big, invisible
            switch (componentName) {
                case "edit-time-range":
                case "copie-day-time-range":
                case "alert":
                case "validation":
                case "providers-status":
                case "double-auth":
                case "move-to":
                case "terms-of-uses":
                    modalTitle = props.title
                    modalClass = "small"
                    break
                case "rgpd":
                    modalTitle = props.title
                    modalClass = "medium"
                    break
            }
            this.emitter.emit("modal", {
                type: componentName,
                layout: layout,
                title: modalTitle,
                transition: props?.transition,
                customClass: modalClass,
                props,
            })
        },
        closeModal(event = null, fonction = null) {
            this.emitter.emit("close-modal", event)
            if (fonction) {
                fonction()
            }
        },
    },
}
export default mixins
